import Vue from 'vue'
import '@/rem/rem.js'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/assets/css/reset.css'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
